import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const DashboardSummaryErrorDocumentIconGroup: React.FC<SvgProps> = (
  props,
) => {
  const fillColor = toSvgColor('#D41515', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.49252 0.985271C3.9956 0.482181 4.66512 0.25 5.3442 0.25H20.3877C25.2611 0.25 29.2428 4.23173 29.2428 9.10507V29.1631C29.2428 29.8421 29.0105 30.5116 28.5075 31.0147C28.0044 31.5179 27.3349 31.75 26.6557 31.75H5.3442C4.66512 31.75 3.9956 31.5179 3.49252 31.0147C2.98943 30.5116 2.75724 29.8421 2.75724 29.1631V2.83696C2.75724 2.15787 2.98943 1.48836 3.49252 0.985271ZM5.42391 2.91667H18.4768V8.02971C18.4768 8.82859 18.7489 9.59792 19.3219 10.1709C19.8948 10.7439 20.6641 11.016 21.4631 11.016H26.5761V29.0833H5.42391V2.91667ZM21.4631 8.34929H26.5297C26.184 5.54884 23.9439 3.30877 21.1435 2.96303V8.02971C21.1435 8.22133 21.2012 8.27896 21.2073 8.28515C21.2135 8.29135 21.2713 8.34929 21.4631 8.34929ZM13.7752 13.4836C13.7752 12.5682 13.0332 11.8262 12.1179 11.8262C11.2026 11.8262 10.4606 12.5682 10.4606 13.4835C10.4606 14.3988 11.2026 15.1408 12.1179 15.1408C13.0332 15.1408 13.7752 14.3988 13.7752 13.4836ZM21.5395 13.4836C21.5395 12.5682 20.7975 11.8262 19.8821 11.8262C18.9668 11.8262 18.2248 12.5682 18.2248 13.4835C18.2248 14.3988 18.9668 15.1408 19.8821 15.1408C20.7975 15.1408 21.5395 14.3988 21.5395 13.4836ZM11.378 22.6927C12.0183 20.7511 13.8475 19.3524 16 19.3524C18.1524 19.3524 19.9817 20.7511 20.622 22.6927C20.8525 23.392 21.6064 23.772 22.3057 23.5413C23.0051 23.3108 23.3851 22.5569 23.1545 21.8576C22.1645 18.8555 19.3375 16.6857 16 16.6857C12.6626 16.6857 9.8354 18.8555 8.84547 21.8576C8.61487 22.5569 8.99485 23.3108 9.6942 23.5413C10.3935 23.772 11.1474 23.392 11.378 22.6927Z"
        fill={fillColor}
      />
    </g>
  );
};

export const DashboardSummaryErrorDocumentIconSvg: React.FC<SvgProps> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...(props.svg ?? {})}
    >
      <DashboardSummaryErrorDocumentIconGroup {...props} />
    </svg>
  );
};
